import { useEffect, useState } from "react";
import api from "../lib/api";

// Loads editable site content for a section (home, about, contact).
// Falls back to provided defaults when API not available.
export default function useSiteContent(section, defaults = {}) {
  const [data, setData] = useState(defaults);

  useEffect(() => {
    let mounted = true;
    api
      .get(`/content/${section}`)
      .then((r) => {
        if (mounted && r.data?.data) setData(r.data.data);
      })
      .catch(() => {});
    return () => { mounted = false; };
  }, [section]);

  return data;
}
